// import React from 'react';
// import { FaEye } from "react-icons/fa";
// import { MdDownloadForOffline } from "react-icons/md";
// import { useDispatch, useSelector } from 'react-redux';
// import { downloadLastPdf, downloadWaiverPdf } from '../redux/apiCalls/accidentApiCall';
// import { ClipLoader } from 'react-spinners';

// function Pdfs() {
//     const {lastAccident, getLoading} = useSelector(state => state.accident)
//     const dispatch = useDispatch()
//     return (
//         <tbody className="flex flex-col w-[100%]">
//             {!getLoading ? <><tr className="bg-white w-[100%] flex justify-between items-center px-4 border-b border-gray-300">
//                 <td className="font-[700] pt-[5px] pb-[5px] cursor-pointer">Abtretungserklärung</td>
//                 <td className="flex items-center">
//                     <button className="text-[#3dba50] transition-all hover:text-green-700 mx-2">
//                         {/* <FaEye className="text-[22px]" /> */}
//                     </button>
//                     <button className="text-[rgb(255,189,89)] transition-all hover:text-blue-700">
//                         <MdDownloadForOffline onClick={() => {
//                             dispatch(downloadWaiverPdf(lastAccident._id, lastAccident.definition))
//                         }} className="text-[25px]" />
//                     </button>
//                 </td>
//             </tr>
//             <tr className="bg-gray-100 w-[100%] flex justify-between items-center px-4 border-b border-gray-300 ">
//                 <td className="font-[700] pt-[5px] pb-[5px] cursor-pointer">Übersicht</td>
//                 <td className="flex items-center">
//                     <button className="text-[#3dba50] transition-all hover:text-green-700 mx-2">
//                         {/* <FaEye className="text-[22px]" /> */}
//                     </button>
//                     <button className="text-[rgb(255,189,89)] transition-all hover:text-blue-700">
//                         <MdDownloadForOffline className="text-[25px]" onClick={()=>{
//                             dispatch(downloadLastPdf(lastAccident._id, lastAccident.definition))
//                         }}/>
//                     </button>
//                 </td>
//             </tr>
//             <tr className="bg-white w-[100%] flex justify-between items-center px-4 border-b border-gray-300 pt-[12px] pb-[12px]">
//                 <td className="font-[700] pt-[5px] pb-[5px]"></td>
//             </tr></>:<div className='text-center mt-[20px]'><ClipLoader color='#000'/></div>}
            
//         </tbody>
//     );
// }

// export default Pdfs;




import React from 'react';
import { FaEye } from "react-icons/fa";
import { MdDownloadForOffline } from "react-icons/md";
import { useDispatch, useSelector } from 'react-redux';
import { downloadLastPdf, downloadWaiverPdf } from '../redux/apiCalls/accidentApiCall';
import { ClipLoader } from 'react-spinners';

function Pdfs() {
    const { lastAccident, getLoading } = useSelector(state => state.accident);
    const dispatch = useDispatch();

    return (
        <tbody className="flex flex-col w-[100%]">
            {!getLoading ? (
                <>
                    <tr className="bg-white w-[100%] flex justify-between items-center px-4 border-b border-gray-300">
                        <td className="font-[700] pt-[5px] pb-[5px] cursor-pointer">Abtretungserklärung</td>
                        <td className="flex items-center">
                            <button className="text-[#3dba50] transition-all hover:text-green-700 mx-2">
                                {/* <FaEye className="text-[22px]" /> */}
                            </button>
                            <button className="text-[rgb(255,189,89)] transition-all hover:text-blue-700">
                                <MdDownloadForOffline 
                                    onClick={() => {
                                        if (lastAccident?._id && lastAccident?.definition) {
                                            dispatch(downloadWaiverPdf(lastAccident._id, lastAccident.definition));
                                        } else {
                                            console.error("Missing accident data.");
                                        }
                                    }} 
                                    className="text-[25px]" 
                                />
                            </button>
                        </td>
                    </tr>
                    <tr className="bg-gray-100 w-[100%] flex justify-between items-center px-4 border-b border-gray-300">
                        <td className="font-[700] pt-[5px] pb-[5px] cursor-pointer">Übersicht</td>
                        <td className="flex items-center">
                            <button className="text-[#3dba50] transition-all hover:text-green-700 mx-2">
                                {/* <FaEye className="text-[22px]" /> */}
                            </button>
                            <button className="text-[rgb(255,189,89)] transition-all hover:text-blue-700">
                                <MdDownloadForOffline 
                                    className="text-[25px]" 
                                    onClick={() => {
                                        if (lastAccident?._id && lastAccident?.definition) {
                                            dispatch(downloadLastPdf(lastAccident._id, lastAccident.definition));
                                        } else {
                                            console.error("Missing accident data.");
                                        }
                                    }}
                                />
                            </button>
                        </td>
                    </tr>
                </>
            ) : (
                <div className='text-center mt-[20px]'><ClipLoader color='#000' /></div>
            )}
        </tbody>
    );
}

export default Pdfs;
